import {connect} from "react-redux"
import State from "../../ducks/state"
import {SupportedRegionTypes} from "../../models/regions"
import {isRelativePath} from "../../utils/configUrlPath"

export const mapStateToProps = (state: State) => {
    const {url, text}: any =
        state.data?.regions.find(region => region.type === SupportedRegionTypes.SecureHelp)?.elements[0] || []
    const {siteUrl} = state.request

    return {
        url: url && isRelativePath(url) ? `${siteUrl}${url}` : url || "",
        text,
        template: state.template,
    }
}

export default connect(mapStateToProps)
